module.exports = __webpack_public_path__ + "d5c057a0c2747af05d6d989d7c88bfc2.png";